export function isArrayN(o: any, n: number, exact: boolean = false) {
  return (
    Array.isArray(o) && ((!exact && o.length >= n) || (exact && o.length === n))
  );
}
